










































































































import QuoteStateMixin from '@/mixins/quoteState';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { mapActions } from 'vuex';
import { QuoteState } from '@/models/quote';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default mixins(QuoteStateMixin, auth).extend({
  name: 'QuoteReviewingDiscountsStateCard',

  components: { ErrorAlert, ConfirmationDialog },

  computed: {
    getColor(): string {
      return 'purple';
    },

    getIcon(): string {
      return 'mdi-percent-box';
    },

    getString(): string {
      return 'Reviewing Discounts';
    },

    getActionText(): string {
      return this.quote.isTariffsApplicable() ? 'Review Surcharges' : 'Approve';
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    ...mapActions({
      calculateCoreDiscountPercent: 'quote/calculateCoreDiscountPercent',
      setQuoteState: 'quote/setQuoteState'
    }),

    approve() {
      return this.setState(QuoteState.APPROVED);
    },

    undoDiscountReview() {
      return this.setState(QuoteState.IN_REVIEW);
    },

    reviewSurcharges() {
      return this.setState(QuoteState.REVIEWING_SURCHARGES);
    },

    setState(state: QuoteState) {
      this.clearAllErrors();

      this.loading = true;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
